import { TileSource, TileVariant, ImpactType } from '../';
import { PublicProjectSummary } from '../projects';
import { dateParser } from '../utils';

export type CarbonOffsetType = {
  _id: string;
  createdAt: string;
  impactType: ImpactType;
  invoiceId?: string;
  isPending?: boolean;
  isMocked?: boolean;
  name?: string;
  numberOfTonnes: number;
  projectId: number;
  projectTitle?: string;
  variant: TileVariant;
  source: TileSource;
  groupId?: number;
};

export class CarbonOffset {
  _id: string;
  createdAt: Date;
  impactType: ImpactType;
  invoiceId?: string;
  isMocked?: boolean;
  isPending?: boolean;
  name?: string;
  numberOfTonnes: number;
  project?: PublicProjectSummary;
  projectId: number;
  projectTitle?: string;
  variant: TileVariant;
  source: TileSource;
  groupId?: number;

  constructor(carbonOffset: CarbonOffsetType, project?: PublicProjectSummary) {
    this._id = carbonOffset._id;
    this.createdAt = dateParser(carbonOffset.createdAt);
    this.impactType = ImpactType.CARBON_OFFSETS;
    this.invoiceId = carbonOffset.invoiceId;
    this.isMocked = carbonOffset.isMocked == true;
    this.isPending = carbonOffset.isPending == true;
    this.name = carbonOffset.name;
    this.numberOfTonnes = carbonOffset.numberOfTonnes;
    this.project = project;
    this.projectId = carbonOffset.projectId;
    this.projectTitle = carbonOffset.projectTitle;
    this.variant = carbonOffset.variant;
    this.source = carbonOffset.source;
    this.groupId = carbonOffset.groupId;
  }
}
